import { render, staticRenderFns } from "./v-error-messages.vue?vue&type=template&id=51d8d38f&"
import script from "./v-error-messages.vue?vue&type=script&lang=js&"
export * from "./v-error-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports